import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import PermissionsOverviewContainer from '~/containers/Permissions/PermissionsOverview';
import { Modal } from '@watcherr/ui';
import PermissionGrantForm from '~/containers/Permissions/PermissionGrantForm';

const AuthorityPage = () => {
  const navigate = useNavigate();
  const onClose = () => {
    navigate(-1);
  };
  return (
    <>
      <PermissionsOverviewContainer />
      <Modal onClose={onClose}>
        <PermissionGrantForm />
      </Modal>
    </>
  );
};

export default dashboardWrapper(AuthorityPage, t('menu.dashboard.authority'));
